import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrencyState } from './currency.state';
import { currencyFeatureKey } from './currency.reducers';

export const selectCurrencyState = createFeatureSelector<CurrencyState>(currencyFeatureKey);

export const selectCurrency = createSelector(selectCurrencyState, (state: CurrencyState) => state);